<template>
  <div v-if="filmtype">
    <app-header
      :title="originalName ? originalName : 'New Film Type'"
      subtitle="Film Type"
    >
      <button class="btn btn-primary" @click="save()">
        Save Changes
      </button>
      <cancel-button />
    </app-header>
    <b-container>
      <b-row>
        <b-col md="4">
          <b-form name="editorForm">
            <!--Category-->
            <b-form-group>
              <label>Categories</label>
              <b-form-checkbox-group v-model="selectedCategories" stacked>
                <b-form-checkbox
                  v-for="category in filmtypecategories"
                  :key="category.id"
                  :value="category.id"
                >
                  {{ category.name }}
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>

            <!--Name-->
            <b-form-group>
              <label>Name ({{ filmtype.name.length }}/20)</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input
                v-model="filmtype.name"
                required
                :state="!!(filmtype.name.length && filmtype.name.length < 21)"
              />
            </b-form-group>

            <!--description-->
            <b-form-group>
              <label>
                Description ({{ filmtype.description.length }}/100)
              </label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input
                v-model="filmtype.description"
                max="100"
                :state="
                  !!(
                    filmtype.description.length &&
                    filmtype.description.length < 101
                  )
                "
              />
            </b-form-group>

            <!--Cycles-->
            <b-form-group>
              <label>Cycles</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input v-model="filmtype.cycles" type="number" />
            </b-form-group>

            <!--Cycles-->
            <b-form-group>
              <label>Alignment Cycles</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input v-model="filmtype.alignment_cycles" type="number" />
            </b-form-group>

            <!--Depth-->
            <b-form-group>
              <label>Depth</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input v-model="filmtype.depth" type="number" />
            </b-form-group>

            <!--Height-->
            <b-form-group>
              <label>Height</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input v-model="filmtype.height" type="number" />
            </b-form-group>

            <!--width-->
            <b-form-group>
              <label>Width</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input v-model="filmtype.width" type="number" />
            </b-form-group>

            <!--default pressure-->
            <b-form-group>
              <label>Pressure</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input v-model="filmtype.pressure" type="number" />
            </b-form-group>

            <!--default speed-->
            <b-form-group>
              <label>Speed</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input v-model="filmtype.speed" type="number" />
            </b-form-group>

            <!--teneth pressure-->
            <b-form-group>
              <label>Teneth Pressure</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input v-model="filmtype.teneth_pressure" type="number" />
            </b-form-group>

            <!--teneth speed-->
            <b-form-group>
              <label>Teneth Speed</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input v-model="filmtype.teneth_speed" type="number" />
            </b-form-group>

            <!--teneth mini pressure-->
            <b-form-group>
              <label>Teneth Mini Pressure</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input
                v-model="filmtype.teneth_mini_pressure"
                type="number"
              />
            </b-form-group>

            <!--teneth mini speed-->
            <b-form-group>
              <label>Teneth Mini Speed</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input
                v-model="filmtype.teneth_mini_speed"
                type="number"
              />
            </b-form-group>

            <!--mycut pressure-->
            <b-form-group>
              <label>Mycut Pressure</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input v-model="filmtype.mycut_pressure" type="number" />
            </b-form-group>

            <!--mycut speed-->
            <b-form-group>
              <label>Mycut Speed</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input v-model="filmtype.mycut_speed" type="number" />
            </b-form-group>

            <!-- Enable Four Seasons -->
            <b-form-group label="Four Seasons Film Type">
              <b-form-select
                v-if="fsfilmtypes"
                v-model="filmtype.fsfilmtype_id"
                :options="fsfilmtypes"
                value-field="id"
                text-field="name"
              />
            </b-form-group>

            <!-- Hidden -->
            <div class="form-check">
              <b-form-checkbox
                v-model="filmtype.hidden"
                class="form-check-input"
              >
                Hidden
              </b-form-checkbox>
            </div>

            <!-- Reversable -->
            <div class="form-check">
              <b-form-checkbox
                v-model="filmtype.reversable"
                class="form-check-input"
              >
                Reversable
              </b-form-checkbox>
            </div>

            <!-- Medium Tablet size -->
            <div class="form-check">
              <b-form-checkbox
                v-model="filmtype.tablet_medium"
                class="form-check-input"
              >
                Medium Tablet Cut Position
              </b-form-checkbox>
            </div>
          </b-form>
        </b-col>
        <b-col md="8" />
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import AppHeader from '@/components/AppHeader';
import CancelButton from '@/components/CancelButton';

export default {
  components: {
    AppHeader,
    CancelButton,
  },

  data() {
    return {
      originalName: null,
      filmtype: null,
      fsfilmtypes: null,
      filmtypecategories: null,
      selectedCategories: [],
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      const isDuplicate = this.$route.query.duplicate;
      $api.get('/v1/internal/fsfilmtypes').then((fsfilmtypes) => {
        this.fsfilmtypes = [{ id: null, name: 'None' }].concat(fsfilmtypes);
      });
      if (this.$route.query.id) {
        $api
          .get(`/v1/internal/filmtypes/${this.$route.query.id}`)
          .then((filmtype) => {
            if (isDuplicate) {
              delete filmtype.id;
              filmtype.name = `Copy of ${filmtype.name}`;
            }
            this.originalName = filmtype.name;
            this.filmtype = filmtype;
            const categories = filmtype.filmtypecategories || [];
            this.selectedCategories = categories.map((c) => c.id);
          });
      } else {
        this.filmtype = {
          name: '',
          description: '',
        };
      }
      this.filmtypecategories = await $api.get('/v1/common/filmtypecategories');
    },

    save() {
      this.filmtype.categories = this.selectedCategories;
      if (this.filmtype.id) {
        $api
          .put(`/v1/internal/filmtypes/${this.filmtype.id}`, this.filmtype)
          .then((filmtype) => {
            this.$router.push({
              name: 'filmtype-detail',
              params: filmtype,
            });
          });
      } else {
        $api.post('/v1/internal/filmtypes/', this.filmtype).then((filmtype) => {
          this.$router.push({
            name: 'filmtype-detail',
            params: filmtype,
          });
        });
      }
    },
  },
};
</script>
